// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface XProductListStateType {
    filterDrawerIsOpen?: boolean;
}

export const initialProductListState: XProductListStateType = {
    filterDrawerIsOpen: false,
};

const reducer = {
    "xProductList/FilterDrawer/SetFilterDrawerIsOpen": (
        draft: Draft<XProductListStateType>,
        action: { filterDrawerIsOpen: boolean },
    ) => {
        draft.filterDrawerIsOpen = action.filterDrawerIsOpen;
    },
};

const xProductList = createTypedReducerWithImmer(initialProductListState, reducer);
(reducers as any).xProductList = xProductList;

export type xProductListState = {
    xProductList: XProductListStateType;
} & ApplicationState;

type xProductListReducers = {
    [key: string]: typeof xProductList;
};

export type xProductListActions = Parameters<xProductListReducers[keyof xProductListReducers]>[1] | AnyAction;
